export const CHECK_IN_ICON_COLOR_MAP = {
    COMPLETE: 'primary.main',
    MISSED: 'error.main',
};
